var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"mall2-client-web@1.2.22"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/pointsmall";

import * as Sentry from "@sentry/nextjs";
import { redactUrl } from "@/utils/redactUrl";

/** 原地把对象里所有带敏感参数的 URL 字符串脱敏（seen 防 extra / contexts 里的循环引用） */
const redactDeep = (value: unknown, seen = new WeakSet<object>()): unknown => {
  if (typeof value === "string") return redactUrl(value);
  if (value && typeof value === "object" && !seen.has(value)) {
    seen.add(value);
    const obj = value as Record<string, unknown>;
    Object.keys(obj).forEach((key) => {
      obj[key] = redactDeep(obj[key], seen);
    });
  }
  return value;
};

// 带免登参数（跨站 udid / App appToken 等）落地的这次页面加载不开回放：
// 录像开头记录页面地址的 Meta 事件没有钩子可改，只能不录
const landedWithCredentials = redactUrl(window.location.href) !== window.location.href;

const domain = process.env.APP_HOST;
if (domain !== "localhost") {
  Sentry.init({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    tunnel: '/pointsmall/api/tunnel',
    tracesSampleRate: 1,
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    debug: false,
    integrations: landedWithCredentials ? [] : [
      Sentry.replayIntegration({
        // Additional Replay configuration goes in here, for example:
        maskAllText: true,
        blockAllMedia: true,
        // 回放录像里的导航、请求记录不经过 event processor，在这里去参数（只会收到这类自定义事件）
        beforeAddRecordingEvent: (event) => {
          redactDeep(event);
          return event;
        },
      }),
    ],
    beforeBreadcrumb(breadcrumb) {
      // console 面包屑的 arguments 会把 axios error 整个序列化（含 Authorization 头、请求体），只留 message
      if (breadcrumb.category === "console") delete breadcrumb.data;
      return breadcrumb;
    },
    environment:process.env.APP_ENV,
    release:process.env.APP_RELEASE,  
  });
  // 错误、transaction、回放事件都会经过这里（beforeSend 只管错误）：
  // 页面地址、面包屑、请求 span 里的 udid / token 等参数统一去掉，不带 cookies
  Sentry.addEventProcessor((event) => {
    redactDeep(event);
    if (event.request) delete event.request.cookies;
    return event;
  });
}

